jQuery(document).ready(function ($) {
  //############################################//
  //###*****   Component - Mobile Menu
  //###*****   Use with styles /styles/components/site-nav.scss

  //############################################//

  $('.js-button-toggle').click(function () {
    $('.c-site-nav__button-container').toggleClass('is-active');

    if ($('.navbar-collapse').hasClass('in')) {
      $('.navbar-collapse').slideUp(250, function () {
        $('.navbar-collapse').removeClass('in').parent().removeClass('active');
        $('.navbar-collapse').removeClass('is-active');
        $('.c-site-header').removeClass('u-sticky');
        $('.c-site-header').removeClass('u-menu-active');
        $('body').removeClass('u-menu-active');
      });
    } else {
      $('.navbar-collapse').slideDown(250, function () {
        $('.navbar-collapse').addClass('in').parent().addClass('active');
        // $('html, body').animate(
        //   {
        //     scrollTop: 0
        //   },
        //   1000
        // )
        $('body').addClass('u-menu-active');
        $('.c-site-header').addClass('u-menu-active');
        $('.navbar-collapse').addClass('is-active');
        $('.c-site-header').addClass('u-sticky');
      });
    }
  });
});
